import { EventSubscription } from '@/models/event-subscription';

export default class UIState {
  testFormView: EventSubscription | null = null;
}
